import CommonModal from "../../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import reboot_image from "../../../asset/image/reboot_image.svg";

interface RouterRebootConfigProps {
    rebootOpen: boolean;
    handleRebootClose: () => void;
    handleRebootConfirm: () => void;
}
const RouterRebootDialog = (props: RouterRebootConfigProps) => {
    const {rebootOpen, handleRebootClose, handleRebootConfirm} = props;

    const element = (
    <div className="routerConfigDialogsContent">
      <img
        src={reboot_image}
        alt="Reboot"
        style={{ padding: "25px 0px 25px 0px" }}
      />
      <div className="routerConfigDialogText">The device is about to reboot.</div>
      <div className="routerConfigDialogText">Internet will be unavailable for few minutes.</div>
    </div>
  );
    return(
        <CommonModal
            open={rebootOpen}
            onClose={handleRebootClose}
            onSave={handleRebootConfirm}
            title={"Reboot"}
            saveText={"Confirm"}
            showOnlineOffline={false}
            showSyncStatus={false}
            children={element}
            width={"458px"}
            height={"278px"}
        />
    )
}

export default RouterRebootDialog;